export const themes = {
  default: {
    thRoot: 'flex justify-center h-full items-center',
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center',
    thRootStyle: { width: '20rem' },
    thLabel: 'inline',
  },
};
